"use client";

import React, { createContext, useContext } from "react";
import type { Role } from "@prisma/client";

interface LotUserContextValue {
  userId: string | null;
  role: Role | null;
  hasUserBids: boolean;
}

const LotUserContext = createContext<LotUserContextValue | undefined>(undefined);

interface LotUserProviderProps {
  value: LotUserContextValue;
  children: React.ReactNode;
}

export const LotUserProvider = ({ value, children }: LotUserProviderProps) => {
  return (
    <LotUserContext.Provider value={value}>
      {children}
    </LotUserContext.Provider>
  );
};

export const useLotUser = () => {
  const ctx = useContext(LotUserContext);
  if (!ctx) {
    throw new Error("useLotUser must be used within a LotUserProvider");
  }
  return ctx;
};


